import Modal from "@/components/Modal";
import Login from "./index";

interface Props {
  visible: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}
export default function ModalLoginView(props: Props) {
  return (
    <Modal visible={props.visible} onClose={props.onClose} closable>
      <div className="mx-auto -mt-[30vh] rounded-xl bg-white px-4 py-6">
        <Login onLoginSuccess={props.onLoginSuccess} />
      </div>
    </Modal>
  );
}
